module.exports = __webpack_public_path__ + "media/images/no-image/no-image-en-0c9eb4580a11400d7d7e2178d309b431.jpg";